// UNKNOWN_ID is the symbol for unknown id
export const UNKNOWN_ID = -1;

// default animation duration
export const ANIMATION_DURATION = 200;

// millisecond in a day
export const DAILY_TIMESTAMP = 3600 * 24 * 1000;

export const VISIBILITY_SELECTOR_ITEMS = ["PRIVATE", "PROTECTED", "PUBLIC"] as const;

// space width for tab action in editor
export const TAB_SPACE_WIDTH = 4;

// Keep the first page small enough for mobile devices. Features that explicitly
// need the complete collection (for example export) use ALL_MEMO_LIMIT instead.
export const DEFAULT_MEMO_LIMIT = 50;
export const ALL_MEMO_LIMIT = 5000;
